    if (!customElements.get('loading-bar')) {
      class LoadingBar extends HTMLElement {
        constructor() {
          super();
          window.addEventListener('beforeunload', () => {
          document.body.classList.add('unloading');
        });

        window.addEventListener('DOMContentLoaded', () => {
          // Keep the original one-second fade without making this critical
          // page-transition guard depend on the below-fold GSAP bundle.
          this.style.animation = 'none';
          if (typeof this.animate === 'function') {
            const fade = this.animate(
              [{ opacity: 1, visibility: 'visible' }, { opacity: 0, visibility: 'hidden' }],
              { duration: 1000, easing: 'ease-out', fill: 'forwards' }
            );
            fade.finished.then(() => {
              this.style.opacity = '0';
              this.style.visibility = 'hidden';
            }).catch(() => {});
          } else {
            this.style.opacity = '0';
            this.style.visibility = 'hidden';
          }

          document.body.classList.add('loaded');
          document.dispatchEvent(new CustomEvent('page:loaded'));
        });

        window.addEventListener('pageshow', (event) => {
          // Removes unload class when returning to page via history
          if (event.persisted) {
            document.body.classList.remove('unloading');
          }
        });
      }
    }
    customElements.define('loading-bar', LoadingBar);
  }
